<template>
  <v-hover v-slot="{ hover }">
    <v-card
      dense
      outlined
      :elevation="hover ? 12 : 2"
      :class="`d-flex on-hover: ${hover} cursor-pointer`"
      @click="visualizarFile"
    >
      <v-card-title class="text-h6 white--text pa-0 pr-3 text-truncate">
        <div class="d-flex align-center text-truncate">
          <v-avatar
            class="ma-3"
            size="32"
            tile
          >
            <v-img :src="thumbnail" />
          </v-avatar>

          <span class="text-truncate py-2">
            {{ file.nome }}
          </span>
        </div>
      </v-card-title>
    </v-card>
  </v-hover>
</template>

<script>
import { ref, watch } from '@vue/composition-api'

export default {
  props: {
    file: {
      type: Object,
      required: true,
    },
  },

  setup(props) {
    const thumbnail = ref(null)

    watch(
      () => props.file,
      v => {
        if (v.contentType === 'application/pdf') {
          thumbnail.value = 'https://upload.wikimedia.org/wikipedia/commons/thumb/8/87/PDF_file_icon.svg/1200px-PDF_file_icon.svg.png'
        } else {
          thumbnail.value = v.url
        }
      },
      {
        immediate: true,
      },
    )

    function visualizarFile() {
      if (!props.file.url) return
      window.open(`${props.file.url}`)
    }

    return {
      thumbnail,
      visualizarFile,
    }
  },
}
</script>
